/* eslint-disable @typescript-eslint/no-namespace */
import {Severity} from "../logger"

export type ConsentCategory = "essential" | "performance" | "functional" | "advertising" | "ccba";
export const ESSENTIAL = "essential";
export const PERFORMANCE = "performance";
export const CCBA = "ccba";
export const COOKIE_CATEGORIES = [ESSENTIAL, PERFORMANCE, "functional", "advertising"] as const;

declare namespace CookieDefinitions {
    type CookieCategory = typeof COOKIE_CATEGORIES[number];

    // Used externally. ccba is stored in a separate cookie under the hood
    interface ConsentCookie {
        essential: boolean,
        performance: boolean,
        functional: boolean,
        advertising: boolean,
        ccba: boolean,
    }

    /**
     * Interface for long-lasting cookie preferences
     * This cookie has a much longer expiration than the main consent cookie
     * New permanent preferences can be added here in the future
     */
    interface PermanentConsentCookie {
        ccba: boolean,
        // Future permanent preferences can be added here
    }    

    interface CookieMetadata {
        id: string;
        version: string;
    }

    interface CompressedCookieMetadata {
        i: string;
        v: string;
    }

    interface InternalConsentCookie extends ConsentCookie, CookieMetadata {

    }

    interface CompressedConsentCookie extends CompressedCookieMetadata {
        e: 0|1,
        p: 0|1,
        f: 0|1,
        a: 0|1
    }
}
export default CookieDefinitions
